export default {
  responsive: true,
  scales: {
    xAxes: [{
      gridLines: {
        display: false
      },
      ticks: {
        maxTicksLimit: 7
      }
    }],
    yAxes: [{
      gridLines: {
        display: false
      },
      ticks: {
        maxTicksLimit: 5
      }
    }]
  }
}
